const BacteriaInRange = ["+1", "+2", "+3", "+4"];

export default BacteriaInRange;
